/**
 * Add classe 'children-input-has-value' to parent Elements
 * Add classe 'children-input-has-focus' to parent Elements
 * 
 */
// push datalayer event on menu click events

window.onload = function() {
    // push datalayer event on page load first time
    function datalayerPageload(event) {
        const bsObjPageLoad = window.dataLayer.filter(x => x.referrer);
        //datalayer code here
        var headingTitle = '';
        if (document.getElementsByTagName('h1').length !== 0) {
            headingTitle = document.getElementsByTagName('h1')[0].innerText
        }

        if (isEmptyObj(bsObjPageLoad, '')) {
            window.dataLayer.push({
                'event': 'PageView',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'referrer': localStorage.getItem("prev_url"),
                'page_title': headingTitle
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'PageView',
                tags: {
                    'event': 'PageView',
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'referrer': localStorage.getItem("prev_url"),
                    'page_title': headingTitle
                }
            });
            localStorage.setItem("prev_url", document.location.href);
        }
    }

    datalayerPageload();

    // push datalayer event on menu click events
    function datalayerObjectMenu(event) {
        const bsObjmenu = window.dataLayer.filter(x => x.page_url);
        //datalayer code here
        var mainMenuHeading = event.target.textContent.trim();
        if (event.target.className && mainMenuHeading != 'Find Local Businesses' && !mainMenuHeading.toLowerCase().includes('login')) {
            return false;
        }
        var mainMenu = event.currentTarget.childNodes[1].textContent.trim();
        if (isEmptyObj(bsObjmenu, '')) {
            window.dataLayer.push({
                'event': 'Menu Selection',
                'login_status': 'unauthenticated',
                'user_id': 'unauthorised',
                'menu_name': mainMenu,
                'submenu_name': '',
                'hostname': document.location.hostname,
                'page_url': document.location.href
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Menu Selection',
                tags: {
                    'login_status': 'unauthenticated',
                    'user_id': 'unauthorised',
                    'menu_name': mainMenu,
                    'submenu_name': '',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href
                }
            });
        }
    }

    const menu = document.querySelectorAll(".b2b-menu-tracking");
    if (menu) {
        for (var i = 0; i < menu.length; i++) {
            menu[i].addEventListener("click", datalayerObjectMenu, false);
        }
    }


    // push datalayer event on submenu click events
    function datalayerObjectSubMenu(event) {
        const bsObjSubMenu = window.dataLayer.filter(x => x.submenu_name);
        //datalayer code here
        var mainMenuName = event.target.parentElement.parentElement.parentElement.parentElement.parentElement.parentElement.getAttribute('x-show');
        if (mainMenuName == null) {
            mainMenuName = event.target.parentElement.parentElement.parentElement.parentElement.getAttribute('x-show');
        }
        mainMenuName = mainMenuName.slice(mainMenuName.indexOf('==') + 3);
        mainMenuName = mainMenuName.replace(/["']/g, "");
        if (isEmptyObj(bsObjSubMenu, '')) {
            window.dataLayer.push({
                'event': 'Menu Selection',
                'login_status': 'unauthenticated',
                'user_id': 'unauthorised',
                'menu_name': mainMenuName,
                'submenu_name': event.currentTarget.textContent.trim(),
                'hostname': document.location.hostname,
                'page_url': document.location.href
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Menu Selection',
                tags: {
                    'login_status': 'unauthenticated',
                    'user_id': 'unauthorised',
                    'menu_name': mainMenuName,
                    'submenu_name': event.currentTarget.textContent.trim(),
                    'hostname': document.location.hostname,
                    'page_url': document.location.href
                }
            });
        }
    }

    const subMenu = document.querySelectorAll(".b2b-submenu-tracking");
    if (subMenu) {
        for (var i = 0; i < subMenu.length; i++) {
            subMenu[i].addEventListener("click", datalayerObjectSubMenu, false);
        }
    }


    // add a business button click datalayer push event
    function datalayerObjectAddBusiness(event) {
        const bsObjAddBusiness = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        // if (isEmptyCTA(bsObjAddBusiness, event.currentTarget.id)) {
        window.dataLayer.push({
            'event': 'Add a Business',
            'login_status': 'unauthenticated',
            'user_id': 'unauthorised',
            'hostname': document.location.hostname,
            'page_url': document.location.href,
            'cta_position_on_page': event.currentTarget.id
        });
        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
            type: 'event',
            eventName: 'Add a Business',
            tags: {
                'login_status': 'unauthenticated',
                'user_Id': 'unauthorised',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_position_on_page': event.currentTarget.id
            }
        });
        // }
    }
    const addBusiness = document.querySelectorAll(".add-a-business");
    if (addBusiness) {
        for (var i = 0; i < addBusiness.length; i++) {
            addBusiness[i].addEventListener("click", datalayerObjectAddBusiness, false);
        }
    }


    // claim your business button click datalayer push event
    function datalayerObjectClaimBusiness(event) {
        const bsObjClaimBusiness = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        // if (isEmptyCTA(bsObjClaimBusiness, event.currentTarget.id)) {
        window.dataLayer.push({
            'event': 'Claim Business Clicked',
            'login_status': 'unauthenticated',
            'user_id': 'unauthorised',
            'hostname': document.location.hostname,
            'page_url': document.location.href,
            'cta_position_on_page': event.currentTarget.id
        });
        window['optimizely'] = window['optimizely'] || [];
        window['optimizely'].push({
            type: 'event',
            eventName: 'Claim Business Clicked',
            tags: {
                'login_status': 'unauthenticated',
                'user_Id': 'unauthorised',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_position_on_page': event.currentTarget.id
            }
        });
        // }
    }
    const claimBusiness = document.querySelectorAll(".claim-your-business");
    if (claimBusiness) {
        for (var i = 0; i < claimBusiness.length; i++) {
            claimBusiness[i].addEventListener("click", datalayerObjectClaimBusiness, false);
        }
    }


    //newsletter subscribe click button click datalayer push event
    function datalayerObjectSubscribeButton(event) {
        const bsObjSubscribeButton = window.dataLayer.filter(x => x.page_url);
        //datalayer code here

        var validationMessage = 'Form Submitted Successfully';

        if (isEmptyObj(bsObjSubscribeButton, 'false')) {
            window.dataLayer.push({
                'event': 'Newsletter Subscribe Clicked',
                'login_status': 'unauthenticated',
                'user_id': 'unauthorised',
                'validation_message': validationMessage,
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_text': 'newsletter_subscribe'
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Newsletter Subscribe Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'user_Id': 'unauthorised',
                    'validation_message': validationMessage,
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'cta_text': 'newsletter_subscribe'
                }
            });
        }
    }
    const subscribeButton = document.querySelector(".ls-enquiry-form-newsletter");
    if (subscribeButton) {
        subscribeButton.addEventListener("submit", function(event) {
            setTimeout(datalayerObjectSubscribeButton, 2000);
        });
    };

    // phone click button click datalayer push event
    function datalayerObjectPhoneClick(event) {
        const bsObjPhoneclick = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        var pagePosition = event.currentTarget.getAttribute('title');
        if (isEmptyCTA(bsObjPhoneclick, '')) {
            window.dataLayer.push({
                'event': 'LS Phone Clicked',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_position_on_page': pagePosition,
                'cta_text': '1300 753 650'
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'LS Phone Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'cta_position_on_page': pagePosition,
                    'cta_text': '1300 753 650'
                }
            });
        }
    }
    const phoneClick = document.querySelectorAll(".b2b-phone-datalayer");
    if (phoneClick) {
        for (var i = 0; i < phoneClick.length; i++) {
            phoneClick[i].addEventListener("click", datalayerObjectPhoneClick, false);
        }
    }

    // email click button click datalayer push event
    function datalayerObjectEmailClick(event) {
        const bsObjEmailclick = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        //var emailText = event.currentTarget.textContent.trim();
        var pagePosition = 'Page Footer'
        if (event.currentTarget.className == 'b2b-email-click-event') {
            pagePosition = 'Contact-Us Page'
        }
        if (isEmptyCTA(bsObjEmailclick, '')) {
            window.dataLayer.push({
                'event': 'Email Lead',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_position_on_page': pagePosition,
                'cta_text': 'enquiries@localsearch.com.au'
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Email Lead',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'cta_position_on_page': pagePosition,
                    'cta_text': 'enquiries@localsearch.com.au'
                }
            });
        }
    }
    const emailClick = document.querySelectorAll(".b2b-email-click-event");
    if (emailClick) {
        for (var i = 0; i < emailClick.length; i++) {
            emailClick[i].addEventListener("click", datalayerObjectEmailClick, false);
        }
    }

    // email click button click datalayer push event
    function datalayerObjectSocialIconClick(event) {
        const bsObjSocialIconClick = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        var emailText = event.currentTarget.getAttribute('social-media');
        var pagePosition = 'Page Footer'

        if (isEmptyCTA(bsObjSocialIconClick, '')) {
            console.log("eqqeqeqeqe")
            window.dataLayer.push({
                'event': 'LS - Social Media Icon Clicked',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_type': window.location.pathname,
                'page_url': document.location.href,
                'cta_position_on_page': pagePosition,
                'cta_text': emailText
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'LS - Social Media Icon Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_type': window.location.pathname,
                    'page_url': document.location.href,
                    'cta_position_on_page': pagePosition,
                    'cta_text': emailText
                }
            });
        }
    }
    const socialIconClick = document.querySelectorAll(".ls-datalayer-event");
    if (socialIconClick) {
        for (var i = 0; i < socialIconClick.length; i++) {
            socialIconClick[i].addEventListener("click", datalayerObjectSocialIconClick, false);
        }
    }


    // email click button click datalayer push event
    function datalayerObjectletsGoClick(event) {
        const bsObjLetsGoClick = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        if (isEmptyCTA(bsObjLetsGoClick, '')) {
            window.dataLayer.push({
                'event': 'Contact Us Clicked',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_position_on_page': event.currentTarget.id
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Contact Us Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'cta_position_on_page': event.currentTarget.id
                }
            });
        }
    }
    const letsGoClick = document.querySelectorAll(".ls-letsgo-event");
    if (letsGoClick) {
        for (var i = 0; i < letsGoClick.length; i++) {
            letsGoClick[i].addEventListener("click", datalayerObjectletsGoClick, false);
        }
    }


    // push datalayer event on menu click events
    function datalayerObjectLoginClick(event) {
        const bsObjmenu = window.dataLayer.filter(x => x.page_url);
        var pageType = "HomePage"
        if (window.location.pathname == '/') {
            pageType = "Homepage"
        } else {
            pageType = window.location.pathname;
        }
        //datalayer code here
        if (isEmptyObj(bsObjmenu, '')) {
            window.dataLayer.push({
                'event': 'Login Clicked',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'cta_position_on_page': 'Page Header',
                'page_type': pageType,
                'page_url': document.location.href
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Login Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'cta_position_on_page': 'Page Header',
                    'page_type': pageType,
                    'page_url': document.location.href
                }
            });
        }
    }

    const loginClick = document.querySelectorAll(".b2b-login-tracking");
    if (loginClick) {
        for (var i = 0; i < loginClick.length; i++) {
            loginClick[i].addEventListener("click", datalayerObjectLoginClick, false);
        }
    }

    function addToDataLayerAuditForms(e) {
        //e.preventDefault()
        const bsObj = window.dataLayer.filter(x => x.form_type);
        //datalayer code here
        if (document.getElementsByClassName('mwa-error').length !== 0) {
            return false;
        }
        if (isEmpty(bsObj)) {
            window.dataLayer.push({
                'event': 'Audit Pages - Form Submit',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'form_type': jQuery('.mwa-widget-container').attr("data-form-type")
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Audit Pages - Form Submit',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'form_type': jQuery('.mwa-widget-container').attr("data-form-type")
                }
            });
        }
    }

    //let button = document.getElementById('mwa-form-mwa-key-*');
    let button = document.querySelector('form[class*=mwa-]')
    if (button) {
        button.addEventListener("submit", function(event) {
            setTimeout(addToDataLayerAuditForms, 1000);
        });
    };

    function eventCtaPos(event) {
        window.eventCtaPos = event.currentTarget.id
        const bsObjeventCtaPos = window.dataLayer.filter(x => x.cta_position_on_page);
        //datalayer code here
        if (isEmptyCTA(bsObjeventCtaPos, '')) {
            window.dataLayer.push({
                'event': 'Talk to Specialist Clicked',
                'login_status': 'unauthenticated',
                'hostname': document.location.hostname,
                'page_url': document.location.href,
                'cta_text': 'Talk to a Specialist',
                'cta_position_on_page': event.currentTarget.id,
                'form_type': 'talk-to-specialist'
            });
            window['optimizely'] = window['optimizely'] || [];
            window['optimizely'].push({
                type: 'event',
                eventName: 'Talk to Specialist Clicked',
                tags: {
                    'login_status': 'unauthenticated',
                    'hostname': document.location.hostname,
                    'page_url': document.location.href,
                    'cta_text': 'Talk to a Specialist',
                    'cta_position_on_page': event.currentTarget.id,
                    'form_type': 'talk-to-specialist'
                }
            });
            console.log("datalayer event passed js");
            elementorProFrontend.modules.popup.showPopup({
                id: '11572'
            });
            document.getElementById('b2b-specialist-form').style.display = 'block';
        }
    }

    const eventCtaPosClick = document.querySelectorAll(".event-cta-pos");
    if (eventCtaPosClick) {
        for (var i = 0; i < eventCtaPosClick.length; i++) {
            eventCtaPosClick[i].addEventListener("click", eventCtaPos, false);
        }
    }

    function isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }

    function isEmptyObj(obj, val) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop) && obj[prop]['event'] === val) {
                return false;
            }
        }
        return true;
    }

    function isEmptyCTA(obj, val) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop) && obj[prop]['cta_position_on_page'] === val) {
                return false;
            }
        }
        return true;
    }
}